import { combineReducers } from 'redux'

import posts from './posts'
import responses from './responses'
import authReducer from './auth'
import allUsers from './allUsers'

export default combineReducers({ posts, responses, authReducer, allUsers })